import type { AssetDetail } from "../api/types";

/** The one question asked before an asset of the organisation is deleted,
 *  built from its detail: what stops, what keeps working, what goes with it. */
export function deleteConfirmText(
  d: Pick<AssetDetail, "meta" | "used_in_count" | "dependents">,
): string {
  let text = `Delete "${d.meta.name}"? New ads will not be able to use it.`;
  if (d.used_in_count > 0)
    text += ` It is still used by ${d.used_in_count} of your ads; those keep working, and its storage is freed when they are deleted.`;
  if (d.dependents.length > 0)
    text += ` This also deletes ${d.dependents.length} ${d.dependents.length === 1 ? "look" : "looks"} saved from it.`;
  return text;
}
